<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="VNコネクト作成"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <div class="mb-1">VNコネクト作成することができます。</div>
                <div class="text-caption">
                  ※アクセス回線申込時の契約帯域によって料金は発生するため、VNコネクト作成の可否で料金の加減は発生しません。
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card variant="outlined" class="h-100">
                  <v-card-text class="text-center">
                    <v-icon
                      icon="$mdiServer"
                      size="50"
                      class="GpuServiceType"
                    />
                    <div class="mt-2 font-weight-bold text-subtitle-1">
                      VNコネクト作成
                    </div>
                    <div class="text-body-2 mb-2">
                      クラウド上の物理サーバーを利用して、専用のネットワーク環境を構築
                    </div>

                    <v-btn
                      class="mt-1 freeBtnStyle"
                      @click="addVnConnect"
                      color="primary"
                    >
                      作成
                    </v-btn>

                    <ul class="ml-2 mt-2 text-left">
                      <li>KDDI GPU Cloudに割り当てた帯域まで利用可能</li>
                      <li>残り設定可能帯域：{{ remainingBandwidthFilter }}</li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import MultiCloudGpuVnLineEdit from "./MultiCloudGpuVnLineEdit.vue";
import type { Line } from "@/apis/CloudLineApi";

export default defineComponent({
  name: "MultiCloudGpuVnConnectionCreate",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    /** 残り帯域 */
    remainingBandwidth: {
      type: Object as PropType<Line["bandwidth"]>,
      required: true,
    },
    cloudVnGpuKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      alertMsg: null as string | null,
    };
  },
  computed: {
    /** 残り設定可能帯域のフィルタ表示 */
    remainingBandwidthFilter(): string {
      return this.$filter.bandwidthTo(this.remainingBandwidth) ?? "0Mbps";
    },
  },
  methods: {
    /** VNコネクト追加 */
    async addVnConnect() {
      this.alertMsg = null;
      await this.$modal.show(MultiCloudGpuVnLineEdit, {
        cloudLineSeq: this.cloudLineSeq,
        cloudVnGpuKeyId: this.cloudVnGpuKeyId,
        remainingBandwidth: this.$filter.bandwidthToBps(
          this.remainingBandwidth
        )!,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>

<style scoped>
.GpuServiceType {
  color: #f5a623;
}
</style>
